import { Observable } from 'rxjs';
import { Actions } from '../../actions';
import {
  GenerateExportUrlSuccess,
  GetEarningsExportUrl,
} from '../action-creators';
import { GENERATE_EXPORT_URL_SUCCESS } from '../actions';
import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';

export const successEarningsExportUrlEpic = (
  action$: Observable<Actions>
): Observable<Actions> =>
  action$.pipe(
    ofType<Actions, GenerateExportUrlSuccess>(GENERATE_EXPORT_URL_SUCCESS),
    map(
      (action) =>
        new GetEarningsExportUrl(action.requestId, action.ownerId)
    )
  );
